import React from 'react'
import SpotifyPlayer from 'react-spotify-player'

// Returns true when the given link points at an Apple Music playlist/album/song.
export const isAppleMusicLink = (link = '') =>
  /music\.apple\.com/i.test(link)

// Apple Music players are embedded by pointing an iframe at the
// embed.music.apple.com host. A regular share link uses the music.apple.com
// host, so we rewrite it here. Links that are already embed links are left
// untouched.
const toAppleEmbedSrc = (link = '') =>
  link.replace(
    /^https?:\/\/(embed\.)?music\.apple\.com/i,
    'https://embed.music.apple.com'
  )

// Renders the appropriate playlist player for the provided link. Apple Music
// links get Apple's iframe embed; everything else falls back to Spotify.
const PlaylistPlayer = ({ uri, size, view, theme }) => {
  if (isAppleMusicLink(uri)) {
    return (
      <iframe
        title="Apple Music playlist"
        allow="autoplay *; encrypted-media *;"
        frameBorder="0"
        height="100%"
        width="100%"
        style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          background: 'transparent',
        }}
        sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
        src={toAppleEmbedSrc(uri)}
      />
    )
  }

  return <SpotifyPlayer uri={uri} size={size} view={view} theme={theme} />
}

export default PlaylistPlayer
